// import * as apiActionsDynamicEndPoint from 'aster-foundation/core/epharmacy/Home/redux/actions';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { getAttributeItemFromArray } from '@common/Utility/common-utils';
import { AE_GLOBAL, HOME_CAROUSELS_ITEM_LIMIT } from '@common/Utility/constants';
import { responsive } from '../CommonProductCarousel/CommonProductCarousel';
import { CommonProductCarouselStyled } from '../CommonProductCarousel/CommonProductCarouselStyled';
import ProductItem from '../ProductItem/ProductItem';
import SectionBox from '../SectionBox/SectionBox';
import SlickSlider from '../SlickSlider/SlickSlider';
import { useNavigationURL } from '@common/Utility/generateNavigationURL';
import { useTranslation } from '@common/i18n';

const RecentlySaved = (props) => {
  const router = useRouter();
  const generateURL = useNavigationURL();
  const t = useTranslation();
  const wishlistData = useSelector((state) => {
    let products = state?.epharmacy?.getWishList?.data?.data;
    products = products?.filter((product) => product.status === '1');
    if (products?.length > HOME_CAROUSELS_ITEM_LIMIT) {
      products = products?.slice(0, HOME_CAROUSELS_ITEM_LIMIT);
    }
    return products;
  });

  const wishlistDataMemo = React.useMemo(() => {
    return wishlistData;
  }, [wishlistData]);

  return (
    <>
      {wishlistDataMemo && wishlistDataMemo?.length > 0 ? (
        <CommonProductCarouselStyled>
          <SectionBox
            title={props?.title}
            customClass="ePharmacy"
            rightTop={
              wishlistDataMemo?.length > 5 && (
                <a
                  className="link me-2"
                  tabIndex="0"
                  role="button"
                  aria-pressed="false"
                  onClick={() => {
                    router.push({
                      pathname: generateURL(`/lists`),
                      query: { screen: `shopping-list` },
                    });
                  }}
                >
                  {t('EPharmacyHome.viewAll')}
                </a>
              )
            }
          >
            <SlickSlider
              sliderSettings={{
                responsive: responsive,
                slidesToShow: 5,
                infinite: false,
                className: '',
                dots: false,
              }}
            >
              {wishlistDataMemo?.map((item, index) => {
                return (
                  <ProductItem
                    key={item?.productId}
                    index={index}
                    avgRating={item?.avgRating}
                    badgeDetails={item?.badgeDetails}
                    offerBadge={item?.badgeDetails?.offerBadge}
                    asterBadge={item?.badgeDetails?.asterBadge[0]}
                    categoryImage={
                      getAttributeItemFromArray(item?.customAttribute, 'small_image')
                        ? getAttributeItemFromArray(item?.customAttribute, 'small_image')
                        : ''
                    }
                    name={item?.name}
                    newPrice={item?.specialPrice}
                    actualPrice={item?.price}
                    isOptics={item?.isOpticalProduct}
                    express={item?.express}
                    isFlash={item?.isFlash}
                    deliverBy={item?.deliverBy}
                    deliveryText={item?.deliveryText}
                    currency={item?.currency}
                    freeDelivery={item?.freeDelivery}
                    outOfStock={item?.outOfStock}
                    sku={item?.sku}
                    availableStock={item?.availableStock || item?.quantity}
                    product={item}
                    orderWithin={item?.orderWithin}
                    sourceContainerTitle={props?.title || t('EPharmacyHome.recentlySaved')}
                    isLoader={false}
                    pageName={'pharmacy_Home_Page'}
                    sectionName={props?.title || t('EPharmacyHome.recentlySaved')}
                    itemListName={props?.title || t('EPharmacyHome.recentlySaved')}
                    itemListId={''}
                    screen={'Epharmacy Homepage'}
                    pageType={'Epharmacy Homepage'}
                    isBundle={item?.isBundled}
                    isScheduled={item?.isScheduled}
                    BundleDetails={item?.tierPrices}
                    BundleImage={item?.small_image}
                    hasRX={item?.itemLabels?.includes(AE_GLOBAL?.RX)}
                  />
                );
              })}
            </SlickSlider>
          </SectionBox>
        </CommonProductCarouselStyled>
      ) : (
        ''
      )}
    </>
  );
};

RecentlySaved.propTypes = {
  isReload: PropTypes.bool,
  title: PropTypes.string,
  viewAllLink: PropTypes.string,
  setLoading: PropTypes.any,
};

export default RecentlySaved;
